import { memo } from 'react';
import type { IIconProps } from '../interfaces';

interface ICaretIconProps extends IIconProps {
  className?: string;
}
const CaretIcon = (props: ICaretIconProps) => {
  const {
    width = 24, height = 24, color = 'currentColor', className,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M19.5 9L12 16.5L4.5 9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(CaretIcon);
